export enum ResourcePath {
	Bookmarks = 'bookmarks',
	Labels = 'bookmarks/labels',
	SuggestedLabels = 'bookmarks/labels/ai_suggested',
}
